import AdminDistricts from './AdminDistricts';
export default AdminDistricts;
